import { Alert, Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import * as UserTypes from 'features/user/userTypes';
import { useEffect, useState } from 'react';
import { Beforeunload } from 'react-beforeunload';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';
import { hasPermission } from 'utils/common';

const MasterNav = (props) => {
  const [state, updateState] = useState({
    onInitialLoad: true,
    refreshKey: 0,
    currentMDItem: null
  });
  const permissions = useSelector((state) => state.user.permissions);
  const planSponsor = useSelector((state) => state.masterTable.planSponsor);
  const planSponsorLoading = useSelector(
    (state) => state.masterTable.planSponsorLoading
  );

  useEffect(() => {
    store.dispatch({
      type: UserTypes.APP_SWITCHED,
      payload: AppConfig.HEADER_MENU_TYPE.STANDARD
    });
  }, []);

  const allTabs = [
    { value: AppConfig.MASTER_DATA_SUB_URL.MASTER_TABLE, label: "Master" },
    { value: AppConfig.MASTER_DATA_SUB_URL.ET_SCHEMA, label: "Election Tier Schema" },
    { value: AppConfig.MASTER_DATA_SUB_URL.EMPLOYEE_CLASS, label: "Employee Class" },
    { value: AppConfig.MASTER_DATA_SUB_URL.ANNUAL_HEALTH_PLAN, label: "Annual Health Plan", disabled: !planSponsor?.name },
    { value: AppConfig.MASTER_DATA_SUB_URL.PLAN_DESIGN_DATA, label: "Plan Design Data" },
    { value: AppConfig.MASTER_DATA_SUB_URL.DENTAL_PLAN, label: "Dental Plan" },
    ...(hasPermission(
      AppConfig.PERMISSION.MD_DISCRECTIONARY_BENEFITS,
      permissions
    ) ? [{ value: AppConfig.MASTER_DATA_SUB_URL.DISCRETIONARY_BENEFITS, label: "Discretionary Benefits" }] : []),
    { value: AppConfig.MASTER_DATA_SUB_URL.VISION_PLAN, label: "Vision Plan" },
    { value: AppConfig.MASTER_DATA_SUB_URL.PLAN_EXPENSE, label: "Plan Expense" },
    { value: AppConfig.MASTER_DATA_SUB_URL.PLAN_RATES, label: "Plan Rates" },
    { value: AppConfig.MASTER_DATA_SUB_URL.STOP_LOSS_CONTRACT, label: "Stop Loss Contract" },
    { value: AppConfig.MASTER_DATA_SUB_URL.DIVISION, label: "Division" }
  ];

  return (
    <>
      <Beforeunload
        onBeforeunload={(event) => {
          if (
            window.location.pathname &&
            window.location.pathname === routePaths.master
          ) {
            if (state.onInitialLoad === true) {
              updateState({ ...state, onInitialLoad: false });
            } else {
              updateState({
                ...state,
                refreshKey: state.refreshKey + 1
              });
            }
          }
        }}></Beforeunload>
      {!planSponsorLoading && !planSponsor?.name && (
        <Alert severity="error" variant="filled">
          Plan Sponsor is not provided
        </Alert>
      )}
      <Tabs
        value={
          (() => {
            const lastSegment = window.location.pathname.split('/').slice(-1)[0];
            return allTabs.some(tab => tab.value === lastSegment) ? lastSegment : false;
          })()
        }
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}
        variant="scrollable">
        {allTabs.map(tab => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            component={Link}
            to={tab.value}
            disabled={tab.disabled}
            sx={tabNoUnderlineSx}
          />
        ))}
      </Tabs>
    </>
  );
};

export default MasterNav;
